import { render, staticRenderFns } from "./StockAuditIndex.vue?vue&type=template&id=60c63f63&scoped=true"
import script from "./StockAuditIndex.vue?vue&type=script&lang=js"
export * from "./StockAuditIndex.vue?vue&type=script&lang=js"
import style0 from "./StockAuditIndex.vue?vue&type=style&index=0&id=60c63f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c63f63",
  null
  
)

export default component.exports